import { render, staticRenderFns } from "./ProductBreadcrumbs.vue?vue&type=template&id=4811331b&"
import script from "./ProductBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ProductBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ProductBreadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports